import React, {useState} from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import './EducationDetails.styles.scss';
import useTranslation from '../../../../translations/use-translation';

const accordionLabelSx = {
  width: "33%",
  flexShrink: 0,
  fontWeight: "700",
  color: "primary.main",
};

const educationTextFieldSx = {
  "& .MuiFormLabel-root": {
    color: "primary.main",
  },
};

const EducationDetails = ({userProfile, setUserProfile}) => {
  const translate  = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [marksType, setMarksType] = useState("CGPA");

  const education = userProfile?.[0]?.education || {};

  const handleChange1 = (event) => {
    setMarksType(event.target.value);
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleEducationDetailsForm = (e) => {
    setUserProfile([
      {
        personal: { ...userProfile[0].personal },
        contacts: { ...userProfile[0].contacts },
        education: { ...userProfile[0].education, [e.target.name]: e.target.value },
        identity: { ...userProfile[0].identity },
      },
    ]);
  };
  return (
    <>
    <div className="education-details-container">
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        className="accordion-styles"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography
            sx={accordionLabelSx}
            className="accordion-label"
          >
            {translate('TENTH')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="form-container">
          <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                id="outlined-basic"
                label={translate('YEAR_OF_PASSING')}
                name="secondaryYop"
             value={education.secondaryYop}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
            <div className="education-form">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={marksType}
                fullWidth={true}
                onChange={handleChange1}
              >
                <MenuItem value={'CGPA'}>{translate('CGPA')}</MenuItem>
                <MenuItem value={'Percentage'}>{translate('PERCENTAGE')}</MenuItem>
              </Select>
            </div>
            <div className="education-form">
              {marksType === "CGPA" ? (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="secondaryCgpa"
                   value={education.secondaryCgpa}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('CGPA')}
                  placeholder={translate('PLACEHOLDER_CGPA')}
                  variant="outlined"
                />
              ) : (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="secondaryPercentage"
                  value={education.secondaryPercentage}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('PERCENTAGE')}
                  placeholder={translate('PLACEHOLDER_PERCENTAGE')}
                  variant="outlined"
                />
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        className="accordion-styles"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography
            sx={accordionLabelSx}
            className="accordion-label"
          >
            {translate('TWELFTH')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <div className="form-container">
        <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('COURSE_NAME')}
                placeholder={translate('COURSE_NAME_PLACEHOLDER')}
                name="seniorSecondaryCourseName"
                 value={education.seniorSecondaryCourseName}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
          <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('YEAR_OF_PASSING')}
                name="seniorSecondaryYop"
                value={education.seniorSecondaryYop}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
            <div className="education-form">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={marksType}
                fullWidth={true}
                onChange={handleChange1}
              >
                <MenuItem value={'CGPA'}>{translate('CGPA')}</MenuItem>
                <MenuItem value={'Percentage'}>{translate('PERCENTAGE')}</MenuItem>
              </Select>
            </div>
            <div className="education-form">
              {marksType === "CGPA" ? (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="seniorSecondaryCgpa"
                  
                  value={education.seniorSecondaryCgpa}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('CGPA')}
                  placeholder={translate('PLACEHOLDER_CGPA')}
                  variant="outlined"
                />
              ) : (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="seniorSecondaryPercentage"
                  
                   value={education.seniorSecondaryPercentage}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('PERCENTAGE')}
                  placeholder={translate('PLACEHOLDER_PERCENTAGE')}
                  variant="outlined"
                />
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
        className="accordion-styles"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel6bh-header"
        >
          <Typography
            sx={accordionLabelSx}
            className="accordion-label"
          >
           {translate('DIPLOMA')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <div className="form-container">
        <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('COURSE_NAME')}
                placeholder={translate('COURSE_NAME_PLACEHOLDER')}
                name="diplomaCourseName"
                 value={education.diplomaCourseName}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
            <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('DIPLOMA_BRANCH')}
                placeholder={translate('DIPLOMA_BRANCH_PLACEHOLDER')}
                name="diplomaBranch"
                value={education.diplomaBranch}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
          <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('YEAR_OF_PASSING')}
                name="diplomaYop"
                value={education.diplomaYop}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
            <div className="education-form">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={marksType}
                fullWidth={true}
                onChange={handleChange1}
              >
                <MenuItem value={'CGPA'}>{translate('CGPA')}</MenuItem>
                <MenuItem value={'Percentage'}>{translate('PERCENTAGE')}</MenuItem>
              </Select>
            </div>
            <div className="education-form">
              {marksType === "CGPA" ? (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="diplomaCgpa"
                  
                  value={education.diplomaCgpa}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('CGPA')}
                  placeholder={translate('PLACEHOLDER_CGPA')}
                  variant="outlined"
                />
              ) : (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="diplomaPercentage"
                  
                   value={education.diplomaPercentage}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('PERCENTAGE')}
                  placeholder={translate('PLACEHOLDER_PERCENTAGE')}
                  variant="outlined"
                />
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        className="accordion-styles"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography
            sx={accordionLabelSx}
            className="accordion-label"
          >
            {translate('GRADUATION')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <div className="form-container">
        <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('COURSE_NAME')}
                name="graduationCourseName"
                placeholder={translate('COURSE_NAME_PLACEHOLDER')}
                 value={education.graduationCourseName}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
          <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('YEAR_OF_PASSING')}
                name="graduationYop"
                value={education.graduationYop}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
            <div className="education-form">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={marksType}
                fullWidth={true}
                onChange={handleChange1}
              >
                <MenuItem value={'CGPA'} >{translate('CGPA')}</MenuItem>
                <MenuItem value={'Percentage'} >{translate('PERCENTAGE')}</MenuItem>
              </Select>
            </div>
            <div className="education-form">
              {marksType === "CGPA" ? (
                 <TextField
                 onChange={handleEducationDetailsForm}
                name="graduationCgpa"
                  
                 value={education.graduationCgpa}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('CGPA')}
                  placeholder={translate('PLACEHOLDER_CGPA')}
                  variant="outlined"
                />
              ) : (
                 <TextField
                 onChange={handleEducationDetailsForm}
                name="graduationPercentage"
                  
                   value={education.graduationPercentage}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('PERCENTAGE')}
                  placeholder={translate('PLACEHOLDER_PERCENTAGE')}
                  variant="outlined"
                />
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
        className="accordion-styles"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography
            sx={accordionLabelSx}
            className="accordion-label"
          >
            {translate('POST_GRADUATION')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <div className="form-container">
        <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('COURSE_NAME')}
                name="postGraduationCourseName"
                placeholder={translate('COURSE_NAME_PLACEHOLDER')}
                 value={education.postGraduationCourseName}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
          <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('YEAR_OF_PASSING')}
                name="postGraduationYop"
                 value={education.postGraduationYop}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
            <div className="education-form">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={marksType}
                fullWidth={true}
                onChange={handleChange1}
              >
                <MenuItem value={'CGPA'}>{translate('CGPA')}</MenuItem>
                <MenuItem value={'Percentage'}>{translate('PERCENTAGE')}</MenuItem>
              </Select>
            </div>
            <div className="education-form">
              {marksType === "CGPA" ? (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="postGraduationCgpa"
                  
                   value={education.postGraduationCgpa}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('CGPA')}
                  placeholder={translate('PLACEHOLDER_CGPA')}
                  variant="outlined"
                />
              ) : (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="postGraduationPercentage"
                  
                   value={education.postGraduationPercentage}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('PERCENTAGE')}
                  placeholder={translate('PLACEHOLDER_PERCENTAGE')}
                  variant="outlined"
                />
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
        className="accordion-styles"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel89bh-content"
          id="panel78bh-header"
        >
          <Typography
            sx={accordionLabelSx}
            className="accordion-label"
          >
            {translate('PHD')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <div className="form-container">
        <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('PHD_COURSE')}
                name="phdCourseName"
                placeholder={translate('PHD_COURSE_PLACEHOLDER')}
                value={education.phdCourseName}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
          <div className="education-form">
               <TextField
                 onChange={handleEducationDetailsForm}
                
                id="outlined-basic"
                label={translate('YEAR_OF_PASSING')}
                name="phdYop"
                 value={education.phdYop}
                sx={educationTextFieldSx}
                fullWidth={true}
                variant="outlined"
              />
            </div>
            <div className="education-form">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={marksType}
                fullWidth={true}
                onChange={handleChange1}
              >
                <MenuItem value={'CGPA'}>{translate('CGPA')}</MenuItem>
                <MenuItem value={'Percentage'}>{translate('PERCENTAGE')}</MenuItem>
              </Select>
            </div>
            <div className="education-form">
              {marksType === "CGPA" ? (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="phdCgpa"
                  
                   value={education.phdCgpa}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('CGPA')}
                  placeholder={translate('PLACEHOLDER_CGPA')}
                  variant="outlined"
                />
              ) : (
                 <TextField
                 onChange={handleEducationDetailsForm}
                  name="phdPercentage"
                  
                   value={education.phdPercentage}
                  id="outlined-basic"
                  sx={educationTextFieldSx}
                  fullWidth={true}
                  label={translate('PERCENTAGE')}
                  placeholder={translate('PLACEHOLDER_PERCENTAGE')}
                  variant="outlined"
                />
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      </div>
      <div className="education-save-btn ">
         <Button
          fullWidth
          className="save-btn-mobile"
           onClick={() => {
           }}
         >
           {translate('SAVE')}
         </Button>
       </div>
   

       </>
  );
};
export default EducationDetails;
